export const customerNumberRE = /^[0-9]{0,6}$/;
export const guaranteedVolumeRE = /^[0-9]{0,6}$/;
